import React, { useContext, useEffect, useState } from 'react'
import Rating from "@mui/material/Rating";
import classes from './Reviews.module.css'
import userImg from '../../../assets/socials/user.svg'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import AuthContext from '../../Common/authContext';
import { addSelectedBook } from '../../redux/productSlice';
import data from '../../Data.json';


const Reviews = () => {
  const language = useSelector((state) => state.products.selectedLanguage[0].Language);
  const user = useSelector((state) => state.products.userInfo);
  const authCtx = useContext  (AuthContext)
  const dispatch = useDispatch()
  const selectedBook = useSelector((state) => state.products.selectedBook[0]);
    const [AddReview, setAddReview] = React.useState(false);
    const [displayedObjects, setDisplayedObjects] = React.useState(2);
    const [review, setReview] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [bookreview, setBookreview] = useState([]);
    const [formData, setFormData] = useState({ rate: 5 });
    const showLess = () => {
        setDisplayedObjects(2); // Show initial number of objects
    };
    
    
  const getToken = () => {
    return sessionStorage.getItem('token');
  };

  const token = getToken()

    const showMore = () => {
        setDisplayedObjects(bookreview?.length); // Show all objects
    };


  
    const fetchBook = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_TESTING_API}/articles?id=${selectedBook?.id}&ecom_type=${process.env.REACT_APP_ECOM_TYPE}`);
        const book = response.data;
        dispatch(addSelectedBook(book))
      } catch (error) {
        // console.error('Error fetching the book:', error);
      }
    };
  
    const fetchReviews = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_TESTING_API}/articles/${selectedBook?.id}/reviews?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`);
          // console.log('Response data:', response.data);
          const reviews = response.data.data;
    
          setBookreview(reviews);
        } catch (error) {
          // console.error('Error fetching reviews:', error);
        }
      };
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };

      const handleSubmit = async (e) => {
        setLoading(true)
        e.preventDefault();
        //   console.log('Review created:', {
        //     ...formData,
        //     user_id: user.id
        // });
        try {
          const response = await axios.post(`${process.env.REACT_APP_TESTING_API}/articles/${selectedBook?.id}/reviews`, {
            ...formData,
            user_id: user.id,
            rate: 0,
            is_counted: false,
            ecom_type: `${process.env.REACT_APP_ECOM_TYPE}`
        }, {
          headers: {
              Authorization: `Bearer ${token}` // Include token in the headers
          }
      });
          fetchReviews();
          fetchBook();
          setFormData({});
          setAddReview(false)
          toast.success( `${language === 'eng' ? 'Review added successfully!' : "Révision ajoutée avec succès !"}` , {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          // Optionally, you can handle success (e.g., show a success message, redirect to another page, etc.)
        } catch (error) {
          // console.error('Error creating review:', error);
          toast.error( `${language === 'eng' ? 'Review submit failed, try agian!' : "L'envoi du commentaire a échoué, essayez à nouveau !"}` , {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          // Optionally, you can handle errors (e.g., show an error message to the user)
        } finally {
          setLoading(false)
        }
      };
    
      // console.log(formData)

    useEffect(() => {
      fetchReviews();
    }, [selectedBook]);

    return (

        <div className={classes.big_con} onClick={()=>console.log(bookreview)}>
            {bookreview?.slice(0, displayedObjects).map((item, index) => (
                <div className={classes.reviews_con} key={item.id} isVisible={index < displayedObjects}>
                        <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'start', paddingBottom: '3%' }}>
                            <img src={item.user.image === "user.png" ? userImg : `${process.env.REACT_APP_TESTING_API_IMAGE}/img/${item.user.image}`} alt="user" style={{ width: "2rem", height: "2rem", marginRight: '2%', borderRadius:'50%' }} />
                            <div  style={{height:"fit-content",margin:"auto 0"}}>
                                <p style={{ lineHeight: '15px',margin:"auto 0" }}>{item.user.first_name} {item.user.last_name}<span style={{background:item.is_counted ? "var(--secondary-color)" : "var(--primary-color)"}} className={classes.countedtag}>{item.is_counted ? language === 'eng' ? 'Rate & Review' :'Noter et évaluer' : language === 'eng' ? 'Comment' :'Commentaire'}</span></p>
                                {item.is_counted && <Rating
                                    style={{
                                        color: "var(--secondary-color)",
                                        justifySelf: 'end',
                                    }}
                                    precision={0.5}
                                    size='small'
                                    name="read-only"
                                    value={item.rate}
                                    readOnly
                                />}
                            </div>
                            </div>
                    <p style={{ width: '100%', textAlign: 'start', paddingBottom: '2%', wordBreak: 'break-word' }}>{item.description}</p>
                    <div style={{ width: '80%', marginLeft: '10%', border: '1px solid var(--secondary-color)' }} /></div>
            ))}
            {bookreview.length > 2 && <>

                {displayedObjects < bookreview.length ? (
                    <p onClick={showMore} style={{ color: "var(--secondary-color)", cursor: 'pointer', paddingTop: '2%' }}>{language === 'eng' ? "SHOW MORE" : "VOIR PLUS"} <ExpandMoreIcon /></p>
                ) : (
                    <p onClick={showLess} style={{ color: "var(--secondary-color)", cursor: 'pointer', paddingTop: '2%' }}>{language === 'eng' ? "SHOW LESS" : "VOIR MOINS"} <ExpandLessIcon /></p>
                )}
            </>} 

                {user && <>
                {!AddReview && <button className={classes.addbtn} onClick={() => setAddReview(true)}>+ {language === 'eng' ? "Write a Comment" : "Écrire Un Commentaire" }</button>}
                {AddReview && <div className={classes.addreview_con}>
                    {/* <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <p>{language === 'eng' ? "Rate this book" : "Notez ce produit"}: </p>
                        <Rating

                            style={{
                                color: "var(--primary-color)",
                                justifySelf: 'end',
                            }}
                            name="rate"
                            onChange={handleChange}
                            // value={item.rate}
                            value={5}
                        />
                    </div> */}
                    <p style={{ lineHeight: '20px', paddingTop: '4%' }}>{language === 'eng' ? "Write a Comment" : "Écrire Un Commentaire" }:</p>
                    <textarea type='textarea' name='description' onChange={handleChange} className={classes.textarea}
                        placeholder={data.placeholders.ReviewInput[language]} />
                    <p>{language === 'eng' ? "Your review will be published to the public." : "Votre avis sera publié publiquement."}</p>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <button className={classes.addbtn} disabled={loading} style={{cursor: loading ? 'wait' : 'pointer'}} onClick={handleSubmit}>{language === 'eng' ? "Publish" : "Publier"}</button>
                        <div className={classes.cancelbtn} onClick={() => setAddReview(false)}>{language === 'eng' ? "Cancel" : "Supprimer"}</div>
                    </div>
                </div>}
                </>}
        </div>

    );
}

export default Reviews